import Icon from 'veui/components/Icon'
import { IconVolume } from 'dls-icons-vue'

Icon.register('volume', IconVolume)
